import "./styles.scoped.css";
export default {
    "root": "awsui_root_r2vco_1bz5w_93"
};
